var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionDropdown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    transform: "translate(-309 -591) translate(105 119) translate(160 464) translate(44 8)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-309 -591) translate(105 119) translate(160 464) translate(44 8) translate(4 4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.333,
    height: 14.222,
    x: 5.333,
    y: 8.889,
    fill: "#FFF",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5A5A5",
    d: "M19.556 14.222L24.889 14.222 22.222 17.778z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionDropdown);
export default __webpack_public_path__ + "static/media/actionDropdown.eb7359a1544c85af1404bd89c8ab2ef9.svg";
export { ForwardRef as ReactComponent };